import React, { useEffect, useState } from "react";
import TextareaAutosize from '@mui/material/TextareaAutosize';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid'; 
import LoadingButton from '@mui/lab/LoadingButton';
import TextField from '@mui/material/TextField';
import { addDoc, collection, setDoc, doc, getDoc } from "firebase/firestore";
import { auth, db } from "../config/FirebaseConfig";
import { useNavigate } from "react-router-dom";
import firebase from "firebase/compat/app";
import "firebase/compat/firestore";
import Chip from '@mui/material/Chip';
import useStore from "../store";
import { async } from "@firebase/util";
import { Stack, Typography } from "@mui/material";
import categoriesConst from "../utilities/constants/Constants"



var randomMC = require('random-material-color');
var Filter = require('bad-words'),
filter = new Filter();
const dayjs = require('dayjs');


const MAX_TEXT_LENGTH = 2500
const numOfWaitingHours = 1

function ConfessionPage() {

  const [text, setText] = useState("");
  const [isTextEmpty, setIsTextEmpty] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [shortText, setShortText] = useState(false);
  const [enableBtn, setEnableBtn] = useState(true);
  const [remainingTime, setRemainingTime] = useState();

  const [categories, setCategories] = useState(categoriesConst);
  const [selectedCategory, setSelectedCategory] = useState(categoriesConst[7]); // 7 is others category


  const userData = useStore((state) => state.userData);

  const postsCollectionRef = collection(db, "posts");
  let navigate = useNavigate();

  const serverStamp = firebase.firestore.Timestamp


  const checkLastTimeAddedPost = async () => {
    const docRef = doc(db, 'users', userData.uid);
    const docSnap = await getDoc(docRef)
    if (docSnap.exists()) {
   
      // //get the time when user added new post to server
      let newDate = new Date(docSnap.data().lastTimeAddedPost.seconds * 1000)
      let Hours = newDate.getHours()
      let Minutes = newDate.getMinutes()
      const HourComplete = Hours + ':' + Minutes
      //console.log("Time when user last time added a confession was: ", HourComplete)
 
      var diff = Math.abs( new Date() - new Date(docSnap.data().lastTimeAddedPost.seconds * 1000));
      var minutes = Math.floor((diff/1000)/60)
      var hoursNum = minutes/60
      
      //180 = 3 hours
      let theRemainingTime = (numOfWaitingHours * 60) - minutes
      let hoursConversion = (theRemainingTime / 60);
      let rhoursConversion = Math.floor(hoursConversion);
      let minutesConversion = (hoursConversion - rhoursConversion) * 60;
      let rminutesConversion = Math.round(minutesConversion);
      //console.log("The remaining time until you can make another confession is: " + rhoursConversion + " hour(s) and " + rminutesConversion + " minute(s).")

      if(hoursNum > numOfWaitingHours){
        setEnableBtn(true)
      }else{
        setRemainingTime("The remaining time until you can make another confession is: " + rhoursConversion + " hour(s) and " + rminutesConversion + " minute(s).")
      }

    }else{
      console.log('Error getting lastTimeAddedPost')
    }
  }

  useEffect(() => {
    checkLastTimeAddedPost();
  }, []);

  const createPost = async () => {

    if(text.length) setIsTextEmpty(false)
    if(text.length >= 25) setShortText(false)

    if(!text.length){
      setIsTextEmpty(true)
      return
    }

    if(text.length < 25){
      setShortText(true)
      return
    }

    let filteredConfession = filter.clean(text)

    setIsLoading(true)
    await addDoc(postsCollectionRef, {
      text: filteredConfession,
      author: { name: userData.displayName, id: userData.uid },
      date: serverStamp.now(),
      university: {
        short: 'sfu',
        long: 'simon fraser university (sfu)'
      },
      likedByCount: 0,
      diLikedByCount: 0,
      categoryCode: selectedCategory.categoryCode
    }).then(async () => {
      //add the last time a user created a post
      await setDoc(doc(db, "users", userData.uid), {
        lastTimeAddedPost: serverStamp.now(),
      }, { merge: true });

    }).catch((error) => {
      console.log('error with updating user: ', error)
    })

    let slectedCategoryCode = selectedCategory.categoryCode
    //After adding a post successfuly -> we get the count of docs and increment it
    let sfuIdInCountCollection = 'T0h0L5acIUJ9zRnZ30AO'
    let posts_count = 'posts_count'
    const docRef = doc(db, posts_count, sfuIdInCountCollection);
    const docSnap = await getDoc(docRef);

    if (docSnap.exists()) {
      console.log("Document data:", docSnap.data());
      let countObject = {
        count_posts: docSnap.data().count_posts + 1,
      }
      let oldCount = docSnap.data()[slectedCategoryCode] || 0
      countObject[slectedCategoryCode] = oldCount + 1
      await setDoc(doc(db, posts_count, sfuIdInCountCollection), countObject, { merge: true });

    } else {
      console.log("No document for count");
    }

    setIsLoading(false)
    navigate("/sfu");
  };

  let generateColor = (text) => {
    return randomMC.getColor({ text: text });
  }

  return (
    <Container maxWidth="sm">
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <TextField
            placeholder="My Confession"
            multiline
            helperText={
              <div>
                {`${text.length}/${MAX_TEXT_LENGTH}`}
                <br/>
                {isTextEmpty && `The confession can not be empty`}
                <br/>
                {shortText && `The confession has to be at least 25 characters`}
              </div>
            }
            //rows={2}
            onChange={(text)=> setText(text.target.value)}
            variant="outlined"
            minRows={10}
            maxRows={10}
            style={{ width: '100%', resize: 'none'}}
            inputProps={{ maxLength: MAX_TEXT_LENGTH }}
            error={isTextEmpty || shortText}
          />
        </Grid>
        <Grid item xs={12}>
          <Stack>
          <Grid container display="flex" justifyContent="center" sx={{mb: 3}}>
            {categories.slice(1).map((category) => {
                return(
                  <Chip
                      variant={"outlined"}
                      //className={styles.badge}
                      sx={{mr: 1, mb: 1}}
                      label={category.categoryValue} 
                      style={{
                        borderColor: generateColor(category.categoryValue) || '#000', 
                        background: selectedCategory.categoryValue === category.categoryValue ? '#d9d9d9' : null
                      }}
                      onClick={() => setSelectedCategory(category)} 
                    />
                )
              })}
            </Grid>
            <Typography variant="p">{`Note: You can make only one confession every ${numOfWaitingHours} hour${numOfWaitingHours> 1 ? 's' : ''}.`}</Typography>
            <Typography variant="p">{remainingTime}</Typography>
            <LoadingButton 
              loading={isLoading}
              onClick={() => createPost()}
              disabled={!enableBtn}
              variant="contained"
              color="error"
              margin='normal'
              sx={{mt: 2, mb: 8}}
            >
              Make a Confession
            </LoadingButton>
          </Stack>
        </Grid>
      </Grid>
    </Container>
  );
}

export default ConfessionPage;
